<div class="filter" fxLayout="row" *ngIf="filterData" [ngClass]="{ hide: !expanded }">
    <div fxFlex="60px" fxFlex.lt-md="60px" class="sampletype-selector">
        <div fxLayout="column">
            <div
                class="st-icon"
                [ngClass]="{ active: isActive('sampleType', sampleType.id) }"
                (click)="onSampleTypeChange(sampleType, true)"
                *ngFor="let sampleType of filterData.filterValues.sampleType"
                appHelpContent
                [helpContent]="sampleType.value"
            >
                <img src="{{ getSampleTypeIcon(sampleType.id) }}" alt="{{ sampleType.value }}" />
            </div>
        </div>
    </div>
    <div fxFlex fxFlex.lt-md="300px" class="filter-panel">
        <div class="toggle-button collapse" [ngClass]="{ show: expanded }" (click)="toggleFilterPanel()"></div>
        <div fxLayout="column" fxFlex>
            <div fxFlex class="filter-container" [class.loaded]="filterLoaded">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <h4 class="filter-title sample-type-title" fxFlex>
                        {{ sampleTypeValue }}
                        <span class="help" appHelpContent [helpContent]="helpContent['sampleTypes']">?</span>
                    </h4>
                </div>

                <app-area-filter
                    [areaSelectLabel]="getCount('seaAreas')"
                    [shapeTypes]="filterData.filterValues.shapeType"
                    [(selectedShapeTypeId)]="selectedShapeTypeId"
                    (selectedShapeTypeIdChange)="onShapeTypeChange($event)"
                    (areaSelectClick)="showPopup(seaAreaFilter)"
                    (resetButtonClick)="resetFilter(true)"
                ></app-area-filter>

                <app-analysis-options
                    [(analysisOptionId)]="selectedAnalysisOptionId"
                    [(selectedSummaryStatisticsId)]="selectedSummaryStatisticsId"
                    (analysisOptionIdChange)="onAnalysisOptionChange($event)"
                    (selectedSummaryStatisticsIdChange)="onSummaryStatisticsChange($event)"
                    [hideMeasurementOption]="selectedSampleTypeId === 4"
                    [selectedNuclideId]="singleSelectedNuclideId"
                ></app-analysis-options>

                <div fxLayout="row">
                    <h6 class="filter-title" fxFlex>Filter settings</h6>
                </div>
                <div *ngIf="isMeasurementAnalysis" fxLayout="row" class="analysis-row">
                    <div>
                        <select id="nuclide-single-select" class="single-select-dropdown" (change)="onNuclideSingleSelectChange()" [(ngModel)]="singleSelectedNuclideId">
                            <option *ngFor="let option of nuclideSingleSelectionList" [disabled]="option.isDisabled" [ngValue]="option.id">
                                {{ option.value }}
                            </option>
                        </select>
                        {{ nuclideUnit }}
                    </div>
                </div>

                <div *ngFor="let item of filters">
                    <ng-container [ngTemplateOutlet]="item.tp" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="toggle-button expand show" *ngIf="!expanded" (click)="toggleFilterPanel()"></div>

<div class="data-export" fxFlex fxLayout="row" fxFlex.lt-md="250px" cdkDrag [ngClass]="{ float: !expanded }">
    <!-- <span>&#10021;</span> -->
    <div fxLayout="column" fxFlex="70">
        <span class="count-label">
            Samples: <b>{{ sampleCount | number : '2.' | noLeadingZero }}</b>
        </span>
        <span class="count-label">
            Measurements: <b>{{ measureCount | number : '2.' | noLeadingZero }}</b>
        </span>
    </div>
    <a class="btn btn-primary px-0" fxFlex="40" (click)="openDialog()">Download CSV</a>
</div>

<div fxLayout="row" fxLayout.xs="column" *ngIf="!filterData" class="filter-skeleton filter">
    <div fxFlex="80px" fxFlex.xs="100" class="sampletype-selector">
        <div fxLayout="column">
            <div class="sk-sampletype" *ngFor="let i of [].constructor(4)"></div>
        </div>
    </div>
    <div fxFlex="400px" fxFlex.xs="100" class="filter-panel">
        <div fxLayout="column" fxFlex>
            <div class="sk-filter-title"></div>
            <div class="filter-group" fxFlex>
                <div class="sk-filter-label"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-label"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
            </div>
            <div class="sk-data-export"></div>
        </div>
    </div>
</div>

<div class="modal-box" *ngIf="showModal" [cdkDrag] [cdkDragDisabled]="isMobileOrTabled">
    <div fxLayout="column" fxFlexFill>
        <div fxLayout="column" class="modal-header">
            <div fxLayout="row" class="border-bottom pb-1" fxFill fxLayoutAlign="space-between center">
                <h6 fxHide.xs class="modal-title">{{ modalTitle }}</h6>
                <div class="modal-buttons" fxLayout.gt-sm="row" fxLayout="row wrap" fxFlex fxLayoutAlign="end center">
                    <div class="filter-q" fxFlex.lt-md fxFlex.gt-sm="250px" fxLayout="row" fxLayoutAlign="space-between center">
                        <input class="border-0" fxFlex.xs="100px" type="text" placeholder="Search" (input)="q($event.target.value)" #messageInput />
                        <i class="fas fa-search"></i>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <a class="btn-cancel" (click)="hidePopup()">Cancel</a>
                        <a fxLayout="row" fxLayoutAlign="center center" class="btn-apply" (click)="applyFilter('filter')">Apply</a>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxFill>
                <div class="modal-toolbar py-2" fxLayout="row" fxFlex="calc(100% - 180px)" fxLayoutAlign="space-between center">
                    <div>
                        <span (click)="selectUnselectAll(modalBoxFilterValues, true)" class="tool-container">
                            <span
                                ><i class="fa fa-plus-square"></i>
                                <span class="ml-1"> Select All </span>
                            </span>
                        </span>
                        <span (click)="selectUnselectAll(modalBoxFilterValues, false)" class="tool-container">
                            <span>
                                <i class="fa fa-minus-square"></i>
                                <span class="ml-1"> Unselect All </span>
                            </span>
                        </span>
                    </div>
                    <div>
                        <span (click)="expandAll(modalBoxFilterValues)" *ngIf="modalBoxFilterValues.parentChild" class="tool-container">
                            <span> Expand All</span>
                        </span>
                        <span (click)="collapseAll(modalBoxFilterValues)" *ngIf="modalBoxFilterValues.parentChild" class="tool-container">
                            <span> Collapse All</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-content" fxLayout="column" fxFlex="calc(100% - 100px)">
            <ng-container [ngTemplateOutlet]="modalBoxFilterValues.tp" [ngTemplateOutletContext]="{ items: modalBoxFilterValues }"></ng-container>
        </div>
    </div>
</div>

<ng-template #dataSelectorTemplate let-item="item">
    <div class="filter-group" *ngIf="showFilter(item.id)">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="filter-value-selection" (click)="showPopup(item)">
            <div fxFlex>{{ item.value }}</div>
            <div class="count-wrapper">
                <span class="count" (click)="showPopup(item)">
                    {{ getCount(item.id) }}
                </span>
            </div>
            <div class="help-wrapper">
                <span class="help" appHelpContent [(helpContent)]="helpContent[item.id]">?</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #sliderTemplate let-item="item">
    <div class="filter-group" fxLayout="column" *ngIf="showFilter(item.id) && resetSlider">
        <h6 class="slider-title">
            {{ item.value }}
            <span class="help" appHelpContent [helpContent]="helpContent['samplingDepth']">?</span>
        </h6>
        <div
            multiHandleRangeSlider
            [(defaultValues)]="defaultValues"
            [(relevantValues)]="relevantValues"
            [(newSelectionValues)]="newSelectionValues"
            [(oldSelectionValues)]="oldSelectionValues"
            [(reset)]="resetSlider"
            name="range-slider"
            (onSlidingEvent)="applySliderValue($event)"
        ></div>
    </div>
</ng-template>

<ng-template #filterValuesListTemplate let-items="items">
    <div *ngIf="items.values.multiColumns" class="list-group" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="1%">
        <ng-container *ngFor="let data of items.values.data">
            <div class="list-group-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px" fxFlex.gt-sm="32">
                <ng-container *ngFor="let item of data">
                    <div  [hidden]="item.isHidden">
                        <div fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="{ 'list-group-panel': items.parentChild }">
                            <!-- Parent Checkbox -->
                            <input
                                type="checkbox"
                                [disabled]="item.isDisabled"
                                [indeterminate]="item.isIndeterminate"
                                [(ngModel)]="item.isSelected"
                                name="list_name"
                                id="parent-{{ item.id }}"
                                value="{{ item.id }}"
                                (ngModelChange)="parentCheck(item)"
                            />
                            <label class="blue-background" for="parent-{{ item.id }}"></label>
                            <div class="check-item text-truncate" [ngClass]="{ 'label-disabled': item.isDisabled }">
                                {{ item.value }}
                            </div>
                            <!-- Parent Arrow -->
                            <span class="arrow-wrapper" (click)="expandCollapse(item)" *ngIf="items.parentChild">
                                <i class="fas fa-angle-down" *ngIf="item.isClosed; else isCollapsed"></i>
                                <ng-template #isCollapsed>
                                    <i class="fas fa-angle-up"></i>
                                </ng-template>
                            </span>
                        </div>
                        <div class="child-list" [hidden]="item.isClosed">
                            <ul class="list-group level-two">
                                <!-- Child Item -->
                                <ng-container *ngFor="let itemChild of item.childList">
                                    <li fxLayout="row" fxLayoutGap="11px" fxLayoutAlign="start center" class="list-group-item level-two" [hidden]="itemChild.isHidden">
                                        <!-- Child Checkbox -->
                                        <input
                                            type="checkbox"
                                            [disabled]="itemChild.isDisabled"
                                            [(ngModel)]="itemChild.isSelected"
                                            name="list_name_child"
                                            id="child-{{ itemChild.id }}"
                                            value="{{ itemChild.id }}"
                                            (ngModelChange)="childCheck(item, item.childList)"
                                        />
                                        <label class="blue-background" for="child-{{ itemChild.id }}"></label>
                                        <div
                                            class="check-item"
                                            [ngClass]="{
                                                'label-disabled': itemChild.isDisabled
                                            }"
                                        >
                                            {{ itemChild.value }}
                                        </div>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div *ngIf="!items.values.multiColumns" class="not-multicolumns list-group" fxLayout="row wrap">
        <!-- Parent Item -->
        <ng-container *ngFor="let item of items.values.data">
            <div fxLayout="column" class="list-group-item" fxFlex="25" fxFlex.xs="50" fxFlex.sm="33" [hidden]="item.isHidden">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" [ngClass]="{ 'list-group-panel': items.parentChild }">
                    <!-- Parent Checkbox -->
                    <input
                        type="checkbox"
                        [disabled]="item.isDisabled"
                        [indeterminate]="item.isIndeterminate"
                        [(ngModel)]="item.isSelected"
                        name="list_name"
                        id="{{ item.id }}"
                        value="{{ item.id }}"
                        (click)="parentShiftHoldCheck(item, items.values.data, $event)"
                    />
                    <label class="blue-background" for="{{ item.id }}"></label>
                    <div class="check-item" [ngClass]="{ 'label-disabled': item.isDisabled }">
                        {{ item.value }}
                    </div>
                    <!-- Parent Arrow -->
                    <span class="arrow-wrapper" (click)="expandCollapse(item)" *ngIf="items.parentChild">
                        <i class="fas fa-angle-down" *ngIf="item.isClosed; else isCollapsed"></i>
                        <ng-template #isCollapsed>
                            <i class="fas fa-angle-up"></i>
                        </ng-template>
                    </span>
                </div>
                <div class="child-list" [hidden]="item.isClosed">
                    <ul class="list-group level-two">
                        <!-- Child Item -->
                        <ng-container *ngFor="let itemChild of item.childList">
                            <li  class="list-group-item level-two" [hidden]="itemChild.isHidden">
                                <!-- Child Checkbox -->
                                <input
                                    type="checkbox"
                                    [disabled]="itemChild.isDisabled"
                                    [(ngModel)]="itemChild.isSelected"
                                    name="list_name_child"
                                    id="{{ itemChild.id }}"
                                    value="{{ itemChild.id }}"
                                    (ngModelChange)="childCheck(item, item.childList)"
                                />
                                <label class="blue-background" for="{{ itemChild.id }}"></label>
                                <div
                                    class="check-item"
                                    [ngClass]="{
                                        'label-disabled': itemChild.isDisabled
                                    }"
                                >
                                    {{ itemChild.value }}
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </ng-container>

        <!--invisible stubs to not expand rest flex items -->
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <div class="list-group-item" [fxFlex]="items.flexWidth"></div>
        <!--invisible stubs to not expand rest flex items -->
    </div>
</ng-template>

<div id="container" *ngIf="showDialog" class="display-dialog">
    <div class="dialog">
        <div *ngComponentOutlet="activeComponent"></div>
    </div>
</div>

<div class="back-drop" [ngClass]="{ show: showModal }"></div>
